export default __webpack_public_path__ + "static/media/todoList.248a5669.jpg";